import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@xxtract/ui';
import { ChangePasswordForm } from '@/features/auth/components/ChangePasswordForm';

/**
 * Thin card wrapper around the EXISTING change-password flow (h12-3 anti-pattern guidance:
 * no second implementation of validation or the API path).
 */
export function ChangePasswordCard() {
  const { t } = useTranslation();

  return (
    <Card data-testid="change-password-card">
      <CardHeader>
        <CardTitle>{t('account.changePassword.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <ChangePasswordForm />
      </CardContent>
    </Card>
  );
}
